import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import style from './acceptQuoteButton.module.scss';
import { Quote } from 'acscp/store';
import classNames from 'classnames';

const AcceptQuoteButtonText: React.FC<{jetCardHolder: boolean}> = ({jetCardHolder}) => {
    return jetCardHolder
        ? (
            <span>
                <FormattedMessage
                    id={'components.quotes.acceptQuoteButton.bookQuote'}
                    defaultMessage={'BOOK'}
                />
            </span>
        ) : (
            <span>
                <FormattedMessage
                    id={'components.quotes.acceptQuoteButton.acceptQuote'}
                    defaultMessage={'ACCEPT'}
                />
            </span>
        );
};

const AcceptQuoteButton: React.FC<{quote: Quote, jetCardHolder: boolean, disabled?: boolean}>
    = ({quote, jetCardHolder, disabled}) => {
        if (quote.status !== 'Accepted') {
            return disabled
                ? (
                    <div className={classNames(style.AcceptButton, style.GreyedOut)}>
                        <AcceptQuoteButtonText jetCardHolder={jetCardHolder} />
                    </div>
                ) : (
                    <Link
                        className={style.AcceptButton}
                        to={`/trip/${quote.bookingId}/quotes/${quote.id}/accept`}
                    >
                        <AcceptQuoteButtonText jetCardHolder={jetCardHolder} />
                    </Link>
                );
        }
        return (
            <div className={style.AcceptedStatus}>
                <FormattedMessage
                    id={'components.quotes.acceptQuoteButton.checkingAvailability'}
                    defaultMessage={'CHECKING AVAILABILITY'}
                />
            </div>
        );

    };

export {AcceptQuoteButton};
